import React from "react";
import { LOGO_URL } from "@/lib/api";

export const Logo = ({ size = 44, withText = true, dark = false }) => {
  return (
    <div className="flex items-center gap-3">
      <img
        src={LOGO_URL}
        alt="Tulsi Jobs"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-full object-cover ring-1 ring-brand-100 bg-white"
      />
      {withText && (
        <div className="leading-tight">
          <div
            className={`font-heading font-bold tracking-tight text-lg ${
              dark ? "text-white" : "text-brand-700"
            }`}
          >
            Tulsi Jobs
          </div>
          <div
            className={`text-[10px] uppercase tracking-[0.2em] ${
              dark ? "text-brand-200" : "text-navy"
            }`}
          >
            Placement Consultant
          </div>
        </div>
      )}
    </div>
  );
};
